import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false
};

export const dragDropSlice = createSlice({
  name: '@@dragDrop',
  initialState,
  reducers: {
    FILE_UPLOAD_START: state => ({
      ...state,
      isUploading: true
    }),
    FILE_UPLOAD_COMPLETE: state => ({
      ...state,
      isUploading: false
    })
  },
  extraReducers: {}
});

export const {
  FILE_UPLOAD_START,
  FILE_UPLOAD_COMPLETE
} = dragDropSlice.actions;

export default dragDropSlice.reducer;
